import { render, staticRenderFns } from "./projectAuthDialog.vue?vue&type=template&id=289c5e8d&scoped=true&"
import script from "./projectAuthDialog.vue?vue&type=script&lang=js&"
export * from "./projectAuthDialog.vue?vue&type=script&lang=js&"
import style0 from "./projectAuthDialog.vue?vue&type=style&index=0&id=289c5e8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c5e8d",
  null
  
)

export default component.exports